import { action } from "mobx";
import AwsS3ListPartRepository from "~/repository/AwsS3/AwsS3ListPartRepository";

class AwsS3ListPartStore {
  /**
   * @property {AwsS3ListPartRepository|null}
   */
  awsS3ListPartRepository = null;

  constructor() {
    this.awsS3ListPartRepository = new AwsS3ListPartRepository();
  }

  @action
  getAll(data) {
    return this.awsS3ListPartRepository.fetch(data);
  }
}

export default AwsS3ListPartStore;
